<template>
  <Menu></Menu>
  <div id="box">
    <div v-if="loading" class="loadingSpinner"><span class="spinner-border"></span></div>
    <!-- =========================================================================================================== -->
    <div class="container mb-2">
      <!-- ----------------------------------------------- -->
      <div class="row">
        <div class="col-auto p-0 text-center">
          <RouterLink class="btn btn-primary w-100 bi-receipt" to="/sales/invoices">&nbsp; All Invoices</RouterLink>
        </div>
        <div class="col p-0 text-center">
          <h5 class="fw-bold d-inline-block bi-receipt">&nbsp; Return Invoice: <span class="select">{{ invoice_id }}</span></h5>
        </div>
        <div class="col-auto p-0 text-center">
          <button class="btn btn-dark w-100 bi-arrow-clockwise" @click="loadInvoice()" :disabled="loading">&nbsp; Reload</button>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0">
          <hr>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0 mb-2">

        <div class="col-auto p-0">
          <div class="input-group w-100">
            <span class="input-group-text">Date: </span>
            <span class="input-group-text"> {{ invoice.date }}</span>
          </div>
        </div>

        <div class="col-auto">
          <div class="input-group w-100">
            <span class="input-group-text">Branch: </span>
            <span class="input-group-text"> {{ invoice.branch }}</span>
          </div>
        </div>
        <div class="col-auto p-0">
          <div class="input-group w-100">
            <span class="input-group-text">Cashier: </span>
            <span class="input-group-text"> {{ invoice.cashier }}</span>
          </div>
        </div>
        
        <div class="col-auto">
          <div class="input-group w-100">
            <span class="input-group-text">Customer Name: </span>
            <span class="input-group-text"> {{ invoice.customerName }}</span>
          </div>
        </div>

        <div class="col-auto p-0">
          <div class="input-group w-100">
            <span class="input-group-text">Customer Phone: </span>
            <span class="input-group-text"> {{ invoice.customerPhone }}</span>
          </div>
        </div>

      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0">
          <table class="table table-sm table-bordered table-striped table-hover table-fixed">
            <!-- ----------------------------------------------- -->
            <thead>
              <tr class="table-dark">
                <th class="">Item</th>
                <th class="w-7 text-center">Quantity</th>
                <th class="w-7 text-center">Quantity Returned</th>
                <th class="w-7 text-center">Price</th>
                <th class="w-7 text-center">Value</th>
                <th class="w-30 text-center">Returns</th>
                <th class="text-center w-100px">
                  <!-- <span class="bi-gear">&nbsp; Return</span> -->
                  <button class="btn btn-sm btn-warning w-100" @click="showReturnAll">Return All</button>
                </th>
              </tr>
            </thead>
            <!-- ----------------------------------------------- -->
            <tbody style="height: calc(100vh - 450px)">        
              <tr v-for="x, i in invoice.items" :key="i">
                <td class="position-relative">
                  {{ x.name }}
                  <span v-if="x.prod_date" class='subtitle'>Production Date: {{ x.prod_date }}</span>
                  <span v-if="x.discount" class="badge text-bg-success disc-badge">{{ (x.discount).toFixed(2) }}%</span>
                </td>
                <td class="w-7 text-center">{{ x.quantity }}</td>
                <td class="w-7 text-center">{{ x.returned }}</td>
                <td class="w-7 text-center">{{ x.price }}</td>
                <td class="w-7 text-center">
                  <span v-bind:class="x.discount ? 'text-decoration-line-through' : ''">
                    {{ (x.price * x.quantity).toFixed(2) }}
                  </span>
                  <span v-if="x.discount" class="d-block">
                    {{ ((x.price * x.quantity) * (1 - x.discount / 100)).toFixed(2) }}
                  </span>
                </td>
                <td class="w-30 text-start">
                  <tr v-for="y, j in x.returns" :key="j" class="w-100" :class="y.timestamp ? 'text-success' : 'text-danger'">
                    <td class="w-10">{{ y.quantity }}</td>
                    <td class="w-50">{{ replace(y.reason) }}</td>
                    <td v-if="y.timestamp" class="w-40">{{ y.timestamp }}</td>
                    <td v-else class="w-40 text-end">
                      Pending
                      <button class="btn btn-sm btn-danger bi-trash py-0" @click="deleteReturn(i, j)"></button>
                    </td>
                  </tr>
                </td>
                <td class="dropstart text-center w-100px">
                  <button class="btn btn-sm btn-primary w-100" @click="showReturn(i)" :disabled="x.returned >= x.quantity">Return</button>
                </td>
              </tr>
            </tbody>
            <!-- ----------------------------------------------- -->
          </table>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col-10 p-0">
          <table class="table table-sm table-bordered fw-bold">
            <tbody>
              <tr>
                <td>Subtotal</td>
                <td class="w-55 text-center">{{ formatMoney(subtotal) }} $</td>
              </tr>
              <!-- --------------------- -->
              <tr v-if="invoice.tax > 0">
                <td>VAT {{ invoice.tax }} %</td>
                <td class="w-55 text-center">{{ formatMoney(subtotal * invoice.tax / 100) }} $</td>
              </tr>
              <!-- --------------------- -->
              <tr class="table-secondary">
                <td>Total</td>
                <td class="w-55 text-center">{{ formatMoney(total) }} $</td>
              </tr>
              <!-- --------------------- -->
              <tr>
                <td></td>
                <td></td>
              </tr>
              <!-- --------------------- -->
              <tr class="table-primary">
                <td>Previously Returned Value</td>
                <td class="w-55 text-center">{{ formatMoney(invoice.returned) }} $</td>
              </tr>
              <!-- --------------------- -->
              <tr class="table-success">
                <td>Current Returned Value</td>
                <td class="w-55 text-center">{{ formatMoney(returned) }} $</td>
              </tr>
            </tbody>
            </table>
        </div>
        <div class="col-2 pb-3">
          <button class="btn btn-success w-100 h-100 fw-bold" @click="confirmReturns()">
            <span class="bi-check-square-fill">&nbsp; Confirm Returns </span>
          </button>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <!-- ----------------------------------------------- -->
    </div>
    <!-- =========================================================================================================== -->
    <!-- =========================================================================================================== -->
    <div id="returnModal" ref="returnModal" class="modal fade">
      <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Return</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body text-center">
            <div v-if="invoice && currReturn.index > -1">

              <div class="input-group w-100 mb-2">
                <span class="input-group-text w-25">Item</span>
                <span class="input-group-text w-75">{{ invoice.items[currReturn.index].name }}</span>
              </div>

              <div class="input-group w-100 mb-2">
                <span class="input-group-text w-25">Sold</span>
                <span class="input-group-text w-25">{{ invoice.items[currReturn.index].quantity }}</span>
                <span class="input-group-text w-25">Returned</span>
                <span class="input-group-text w-25">{{ invoice.items[currReturn.index].returned || 0}}</span>
              </div>

              <hr>

              <div class="input-group w-100 mb-2">
                <span class="input-group-text w-25">Return</span>
                <span class="input-group-text w-50">
                  <input type="range" v-model="currReturn.returned" min="0" :max="invoice.items[currReturn.index].quantity - (invoice.items[currReturn.index].returned || 0)" step="1" class="form-range">
                </span>
                <input type="number" v-model.number="currReturn.returned" min="0" :max="invoice.items[currReturn.index].quantity - (invoice.items[currReturn.index].returned || 0)" class="form-control text-center" @input="limit()">
              </div>
              
              <div class="input-group w-100">
                <span class="input-group-text w-25">Reason</span>
                <select class="form-select" v-model="currReturn.reason">
                  <option value="cr">Customer Request</option>
                  <option value="doa">Damage on Arrival</option>
                </select>
              </div>

            </div>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col text-center">
                  <a class="btn btn-success w-50" @click="addReturn()">Apply</a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <div id="returnAllModal" ref="returnAllModal" class="modal fade">
      <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Return All</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body text-center">

              <div class="input-group w-100">
                <span class="input-group-text w-25">Reason</span>
                <select class="form-select" v-model="currReturn.reason">
                  <option value="cr">Customer Request</option>
                  <option value="doa">Damage on Arrival</option>
                </select>
              </div>

          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col text-center">
                  <a class="btn btn-success w-50" @click="addAllReturn()">Apply To All</a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>    <!-- =========================================================================================================== -->
  </div>

</template>
<!-- ******************************************************** -->
<script>
  const $ = require('jquery');
  export default {
    name: 'ReturnPage',
    props: {
      id: {
        type: String,
        default: '',
      },
    },
    data(){
      return {
        invoice_id: '',
        invoice:{

        },
        currReturn: {
          index: -1,
          reason: 'cr',
          returned: 0,
        }
      }
    },
    created() {
      this.invoice_id = this.$route.params.id;
      this.loadInvoice();
    },
    mounted(){
    },
    ////////////////////////////////////////////////////////////////
    computed:{
      subtotal(){
        if(!this.invoice || !this.invoice.items) return "0.00";
        var x = this.invoice.items.reduce((acc, x)=> acc + (x.price * x.quantity) * (1 - (x.discount || 0) / 100), 0);
        return parseFloat(x.toFixed(2))
      },
      total(){
        if(!this.invoice || !this.invoice.items) return "0.00";
        var x = this.subtotal * (this.invoice.tax/100 + 1);
        return parseFloat(x.toFixed(2))
      },
      // prev_returned(){
      //   if(!this.invoice || !this.invoice.items) return "0.00";
      //   var x = this.invoice.items.reduce((acc, x)=> {
      //     let count = (x.returns || []).reduce((acc2, x2)=> acc2 + (x2.timestamp ? x2.quantity : 0), 0);
      //     return acc + (x.price * count) * (1 - (x.discount || 0) / 100);
      //   }, 0);
      //   x = x * (1 + (this.invoice.tax || 0)/100);
      //   return parseFloat(x.toFixed(2))
      // },
      returned(){
        if(!this.invoice || !this.invoice.items) return "0.00";
        var x = this.invoice.items.reduce((acc, x)=> {
          let count = (x.returns || []).reduce((acc2, x2)=> acc2 + (!x2.timestamp ? x2.quantity : 0), 0);
          return acc + (x.price * count) * (1 - (x.discount || 0) / 100);
        }, 0);
        x = x * (1 + (this.invoice.tax || 0)/100);
        return parseFloat(x.toFixed(2))
      },
    },
    ////////////////////////////////////////////////////////////////
    methods:{
      //**********************************************************
      async loadInvoice(){
        this.loading = true;
        this.currReturn.index = -1;
        this.invoice = {};
        var ack = await this.$service.getInvoice({ id: this.invoice_id });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.invoice = ack.data;
        }
        this.loading = false;
      },
      //**********************************************************
      async showReturnAll(){
        $('#returnAllModal').modal('show');
      },
      //**********************************************************
      addAllReturn(){
        for(let i=0;i<this.invoice.items.length;i++){
          this.currReturn.index = i;
          this.currReturn.returned = this.invoice.items[i].quantity - (this.invoice.items[i].returned || 0);
          if(this.currReturn.returned == 0) continue;
          this.addReturn();
        }
        $('#returnAllModal').modal('hide');
      },
      //**********************************************************
      async showReturn(index){
        if(this.invoice.items[index].quantity < 1){
          return this.$toast('No Enough', 'warning');
        }
        this.currReturn.index = index;
        this.currReturn.reason = 'cr';
        this.currReturn.returned = 0;
        $('#returnModal').modal('show');
      },
      //**********************************************************
      addReturn(){
        this.currReturn.returned = parseInt(this.currReturn.returned);
        if(this.currReturn.returned < 1){
          return this.$toast('Invalid Amount', 'warning');
        }
        var curr = this.invoice.items[this.currReturn.index];

        if((this.currReturn.returned + (curr.returned || 0)) > curr.quantity){
          return this.$toast('No Enough', 'warning');
        }

        if(!curr.returns) curr.returns = [];
        
        //search for the record
        var i = curr.returns.findIndex((x)=>!x.timestamp && x.reason == this.currReturn.reason);
        if(i == -1){
          //add new record
          curr.returns.push({
            reason: this.currReturn.reason,
            quantity: this.currReturn.returned,
          });
        }
        else{
          //accumulate to existing record
          curr.returns[i].quantity += this.currReturn.returned;
        }

        // curr.quantity -= this.currReturn.returned;
        curr.returned = (curr.returned || 0) + this.currReturn.returned;
        // this.calcReturned();
        $('#returnModal').modal('hide');
      },
      //**********************************************************
      limit(){
        if(this.currReturn.returned < 0){
          this.currReturn.returned = 0;
        }
        if(this.currReturn.returned > this.invoice.items[this.currReturn.index].quantity){
          this.currReturn.returned = this.invoice.items[this.currReturn.index].quantity;
        }
      },
      //**********************************************************
      replace(text){
        return {
          'cr': 'Customer Request',
          'doa': 'Damage on Arrival',
        }[text];
      },
      //**********************************************************
      deleteReturn(i, j){
        // this.invoice.items[i].quantity += this.invoice.items[i].returns[j].quantity;
        this.invoice.items[i].returned -= this.invoice.items[i].returns[j].quantity;
        this.invoice.items[i].returns.splice(j, 1);
        // this.calcReturned();
      },
      //**********************************************************
      // calcReturned(){
      //   this.invoice.returned = this.invoice.items.reduce((acc, x)=> acc + ((x.returned || 0) * x.price), 0);
      // },
      //**********************************************************
      async confirmReturns(){
        if(this.returned == 0) {
          return this.$toast("No Returns to proceed");
        }
        var reply = await this.$swal.fire({
          title: "Confirm Return",
          html: `Are you sure you want to return items from the invoice ?`,
          icon: "warning", showCancelButton: true, focusCancel: true,
          confirmButtonText: "Confirm Return", confirmButtonColor: "#0D6EFD", 
        });
        if(!reply.isConfirmed) return;

        this.invoice.new_returned = this.returned;
        var ack = await this.$service.returnInvoice({invoice: this.invoice});
        if(ack.state != 'OK') return this.$toast(ack.state);
        this.$toast('Invoice Returned', 'success');
        await this.loadInvoice();
      }
      //**********************************************************
      //**********************************************************
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
.disc-badge{
  position: absolute;
  top: 5px;
  right: 5px;
}
</style>
  